<template>
  <transition name="bounce">
    <div v-if="updateStore.alert && updateStore.alertVisible" class="card issue-notification">
      <h5 class="d-flex align-items-center"><warning-illustration style="width: 40px; height: 40px"/> <span class="ml-2">{{ updateStore.alert.title }}</span></h5>
      <span v-html="updateStore.alert.content"/>
    </div>
  </transition>
</template>
<script setup>
  import WarningIllustration from '@/components/illustrations/warning.vue';
  import { useUpdateStore } from '@/stores/update';

  const updateStore = useUpdateStore();
</script>
